<template>
  <div :class="(className ? className + ' ': '') + 'col-md-12 text-center title-logo-png'">
    <a :href="url">
    <img src="../../../public/img/logo.png" class="logo" alt="logo">
    </a>
  </div>
</template>

<script>
export default {
  props: {
    className: String,
    url: String
  }
}
</script>
